import { PRIVATE } from '@/plugins/acl/const'
import comingSoonRoute from '@/router/utils/comingSoonRoute'

const settings = [
  {
    path: '/settings/organization',
    name: 'settings-organization',
    component: () => import('@/views/settings/organization/company-view/CompanyView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.SETTINGS.COMPANY,
    },
  },
  {
    path: '/settings/users',
    name: 'settings-users-list',
    component: () => import('@/views/settings/users/user-list/UserList.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.SETTINGS.USER_MANAGEMENT,
    },
  },
  {
    path: '/settings/users/:id',
    name: 'settings-users-view',
    component: () => import('@/views/settings/users/user-view/UserView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.SETTINGS.USER_MANAGEMENT,
      breadCrumb(context) {
        return [
          {
            text: 'userManagement',
            useI18n: true,
            to: { name: 'settings-users-list' },
          },
          {
            text: context.recruiterName,
            useI18n: false,
          },
        ]
      },
    },
  },
  {
    path: '/settings/recruitment',
    name: 'settings-recruitment',
    component: () => import('@/views/settings/recruitment/JobsSettingsView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.SETTINGS.JOBS,
    },
  },
  comingSoonRoute({
    path: '/settings/legalization-of-stay',
    name: 'settings-legalization-of-stay',
    comingSoonKey: 'settingsLegalizationOfStay',
    resource: PRIVATE.SETTINGS.LEGALIZATION_OF_STAY,
    chickenImage: 'comingSoon.png',
  }),
  comingSoonRoute({
    path: '/settings/legalization-of-work',
    name: 'settings-legalization-of-work',
    comingSoonKey: 'settingsLegalizationOfWork',
    resource: PRIVATE.SETTINGS.LEGALIZATION_OF_WORK,
    chickenImage: 'comingSoon.png',
  }),
  {
    path: '/settings/employee',
    name: 'settings-employee',
    component: () => import('@/views/settings/employee/EmployeeSettingsView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.SETTINGS.EMPLOYEES,
    },
  },
  comingSoonRoute({
    path: '/settings/working-time-records',
    name: 'settings-working-time-records',
    comingSoonKey: 'settingsWorkingTimeRecords',
    resource: PRIVATE.SETTINGS.WORKING_TIME_RECORDS,
    chickenImage: 'comingSoon.png',
  }),
  {
    path: '/settings/client',
    name: 'settings-client',
    component: () => import('@/views/settings/client/ClientSettingsView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.SETTINGS.CLIENTS,
    },
  },
  comingSoonRoute({
    path: '/settings/leads',
    name: 'settings-leads',
    comingSoonKey: 'settingsLeads',
    resource: PRIVATE.SETTINGS.LEADS,
    chickenImage: 'comingSoon.png',
  }),
  {
    path: '/settings/workstations',
    name: 'settings-workstations',
    component: () => import('@/views/settings/workstations/ProjectSettingsView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.SETTINGS.PROJECTS,
    },
  },
  {
    path: '/settings/apartments',
    name: 'settings-apartments',
    component: () => import('@/views/settings/apartments/HouseSettingsView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.SETTINGS.HOUSES,
    },
  },
  comingSoonRoute({
    path: '/settings/fleet',
    name: 'settings-fleet',
    comingSoonKey: 'settingsFleet',
    resource: PRIVATE.SETTINGS.FLEET,
    chickenImage: 'comingSoon.png',
  }),
  comingSoonRoute({
    path: '/settings/resources',
    name: 'settings-resources',
    comingSoonKey: 'settingsResources',
    resource: PRIVATE.SETTINGS.RESOURCES,
    chickenImage: 'comingSoon.png',
  }),
]

export default settings
